import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, Text, useTheme } from '@Sage/hoi-poi-ui';

import { BillboardActions } from 'actions';
import { PATH_IMAGE } from 'constants/Environment';
import { getLiteral } from 'utils/getLiteral';

const BillboardSuccessDialog = memo(() => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const open = useSelector((state) => state.billboard.showSuccessDialog);

    const handleClose = useCallback(() => {
        dispatch(BillboardActions.showCreateSuccessDialog(false));
    }, [dispatch]);

    useEffect(() => {
        if (!open) return undefined;
        const timer = window.setTimeout(handleClose, 3000);
        return () => window.clearTimeout(timer);
    }, [handleClose, open]);

    return (
        <Modal
            isOpen={open}
            onRequestClose={handleClose}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            size="medium"
            useCornerClose={false}
            useHeader={false}
        >
            <div className="billboard-success-dialog">
                <img
                    alt=""
                    className="billboard-success-dialog__image"
                    src={`${PATH_IMAGE}img_published.png`}
                />
                <Text as="div" bold className="billboard-success-dialog__title" type="subtitle1">
                    {getLiteral('success_billboard_post_published')}
                </Text>
                <Text
                    as="div"
                    className="billboard-success-dialog__subtitle"
                    color={theme.colors.utility.textSecondary}
                    type="body"
                >
                    {getLiteral('label_billboard_post_published')}
                </Text>
                <Button
                    className="billboard-success-dialog__action"
                    onClick={handleClose}
                    type="primary"
                >
                    {getLiteral('action_close')}
                </Button>
            </div>
        </Modal>
    );
});

BillboardSuccessDialog.displayName = 'BillboardSuccessDialog';

export default BillboardSuccessDialog;
